import styles from "./index.module.less";
import {Icon} from "@blueprintjs/core";
import React from "react";

const TabTitle = ({ label, onClose }) => {
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose && onClose();
  };
  return (
    <div className={styles['tab-title']}>
      <span>{label}</span>
      <span onClick={handleClose}>
        <Icon icon='cross' iconSize={8}/>
      </span>
    </div>
  );
};

export default TabTitle;
